import { CircularProgress } from '@mui/material';

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = 'Loading...' }: LoadingStateProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
        <div className="flex items-center justify-center mb-4">
          <CircularProgress size={32} />
        </div>
        <p className="text-center text-gray-700">{message}</p>
      </div>
    </div>
  );
}
